(ns minorodata.unleash.core
  (:require [applied-science.js-interop :as jsi]
            [unleash-proxy-client :refer [UnleashClient]]
            [minorodata.app.handlers :refer [dispatch]]
            [minorodata.app.config :refer [UNLEASH_HOST UNLEASH_CLIENT_KEY UNLEASH_APP]]))


(defn- loaded-user-id
  [client]
  (when (and (jsi/call client :isReady)
             (nil? (jsi/call client :getError)))
    (jsi/get (jsi/call client :getContext) :userId)))


(defn dispatch-toggles-loaded!
  [client]
  (dispatch [:unleash/toggles-loaded (js/Date.now) (loaded-user-id client)]))


(defonce unleash
  (let [client (UnleashClient.
                #js {:url       UNLEASH_HOST
                     :clientKey UNLEASH_CLIENT_KEY
                     :appName   UNLEASH_APP})]
    (jsi/call client :on "update" #(dispatch-toggles-loaded! client))
    (jsi/call client :on "ready" #(dispatch-toggles-loaded! client))
    client))

